import React from 'react';

const ResultsRow = (props) => {
	const range = (props.lowincome === 'true') ? props.result.rangeLow : props.result.range;

	return (
		<div className={props.classes}>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-savings">
					<p>{props.content.provincialTitle}</p>
					<p className="app__results_range-title--super">{props.content.provincialSuper}</p>
					<div className="app__results_range-title">{range}</div>
				</div>
			</div>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-thankyou">
					<p>{props.result.copy}</p>
					{ props.result.sourceUrl &&
						<p><a className="app__results-source" target="_blank" href={props.result.sourceUrl}>{props.result.source}</a></p>
					}
				</div>
			</div>
		</div>
	);
};

export default ResultsRow;



// WEBPACK FOOTER //
// ./src/components/ResultsRow.js